import RecaptchaLoader from '../utils/recaptcha-loader.js';

const Newsletter = (function () {
	return {
		init: function () {
			const forms = document.querySelectorAll('.newsletter-form');

			forms.forEach(function (form, formIndex) {
				// Load reCAPTCHA when user starts interacting with the form
				const inputs = form.querySelectorAll('input, textarea');
				let recaptchaLoaded = false;

				const loadRecaptchaOnInteraction = () => {
					if (!recaptchaLoaded) {
						recaptchaLoaded = true;
						RecaptchaLoader.load().catch(error => {
							// Silent error handling for production
						});
						
						// Remove listeners after loading
						inputs.forEach((input, inputIndex) => {
							input.removeEventListener('focus', loadRecaptchaOnInteraction);
							input.removeEventListener('input', loadRecaptchaOnInteraction);
						});
					}
				};

				// Add listeners to trigger reCAPTCHA loading
				inputs.forEach((input, inputIndex) => {
					input.addEventListener('focus', loadRecaptchaOnInteraction);
					input.addEventListener('input', loadRecaptchaOnInteraction);
				});

				form.addEventListener('submit', async function (e) {
					e.preventDefault();

					const successMsg = form.querySelector('.mailpoet_validate_success');
					const errorMsg = form.querySelector('.mailpoet_validate_error');

					successMsg.style.display = 'none';
					errorMsg.style.display = 'none';
					errorMsg.textContent = '';

					try {
						const token = await RecaptchaLoader.execute('newsletter_form');
						
						let tokenInput = form.querySelector('input[name="g-recaptcha-response"]');
						if (!tokenInput) {
							tokenInput = document.createElement('input');
							tokenInput.type = 'hidden';
							tokenInput.name = 'g-recaptcha-response';
							form.appendChild(tokenInput);
						}
						tokenInput.value = token;

						const formData = new FormData(form);
						const action = form.getAttribute('action');

						const response = await fetch(action, {
							method: 'POST',
							body: formData,
							credentials: 'same-origin'
						});

						if (response.redirected) {
							successMsg.style.display = 'block';
							form.reset();
						} else {
							const text = await response.text();
							errorMsg.textContent = text;
							errorMsg.style.display = 'flex';
						}
					} catch (error) {
						errorMsg.textContent = 'Nastala chyba pri odosielaní formulára. Skús to znova.';
						errorMsg.style.display = 'block';
					}
				});
			});
		}
	};
})();

export default Newsletter;
